import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

/**
 * Little info-card used on the Overview screen
 */
const StatCard = ({ title, value, icon: Icon, trend, color = 'blue' }) => {
  const colorMap = {
    blue: 'text-blue-600 border-blue-500',
    green: 'text-green-600 border-green-500',
    red: 'text-red-600 border-red-500',
    yellow: 'text-yellow-600 border-yellow-500',
  };
  const border = colorMap[color] ?? colorMap.blue;

  return (
    <div className={`bg-arc-elevated rounded-lg shadow-md p-6 border-l-4 ${border}`}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-arc-muted text-sm font-medium">{title}</p>
          <p className={`text-2xl font-bold ${border.split(' ')[0]}`}>
            {typeof value === 'number' ? `$${value.toLocaleString()}` : value}
          </p>
          {trend !== undefined && (
            <p
              className={`text-sm flex items-center ${
                trend > 0 ? 'text-green-600' : 'text-red-600'
              }`}
            >
              {trend > 0 ? (
                <TrendingUp size={16} />
              ) : (
                <TrendingDown size={16} />
              )}
              {Math.abs(trend)}%
            </p>
          )}
        </div>
        <Icon className={border.split(' ')[0]} size={32} />
      </div>
    </div>
  );
};

export default StatCard;
